import styled from 'styled-components';

export const StyledLink = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  > span {
    color: #4c458a;
    font-weight: bold;
  }
`;

export const MenuWrapper = styled.div`
  display: none;
  @media (min-width: 768px) {
    width: 608px;
    margin: 0 auto;
    display: block;
  }
`;
